import { useState, CSSProperties, useEffect } from 'react';
import getOffset from '../../utils/getOffset';

interface IProps {
  selectWrapper: HTMLDivElement,
  bodyElement?: HTMLElement,
  getMenuOuterStyle?: (defaultStyle: () => CSSProperties, container: HTMLDivElement) => CSSProperties,
}

const useMenuOuterStyle = ({ selectWrapper, bodyElement, getMenuOuterStyle }: IProps) => {
  const [menuOuterStyle, setMenuOuterStyle] = useState<CSSProperties>({});

  const getMenuOuterStyleDefault = (): CSSProperties => {
    const offset = getOffset(selectWrapper, bodyElement);
    const style = {
      position: 'fixed',
      margin: `${ offset.height }px 0 0 0`,
      width: offset.width,
      left: offset.left,
      top: offset.top,
    };

    if (bodyElement && (offset.top + 230 > bodyElement.offsetHeight)) {
      style.top = offset.top - 200;
      style.margin = '0 0 30px';
    }

    return style as CSSProperties;
  };

  const getOuterStyle = () => {
    return typeof getMenuOuterStyle === 'function'
      ? getMenuOuterStyle(getMenuOuterStyleDefault, selectWrapper)
      : getMenuOuterStyleDefault();
  };

  useEffect(() => {
    setMenuOuterStyle(getOuterStyle());
  }, [getMenuOuterStyle, selectWrapper, bodyElement]);

  return {
    menuOuterStyle,
    getOuterStyle,
    setMenuOuterStyle,
  };
};

export default useMenuOuterStyle;
